import { Link } from "react-router-dom";
import { categories } from "@/utils/news";

const friendLinks = [
  { label: "热点新闻聚合", href: "#" },
  { label: "娱乐资讯观察", href: "#" },
  { label: "网络热梗词典", href: "#" },
  { label: "城市生活指南", href: "#" },
];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-secondary-950 text-secondary-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-lg text-background-50">
                <i className="ri-fire-line"></i>
              </span>
              <span className="font-heading text-xl font-black text-background-50">
                51吃瓜网站
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-300">
              51吃瓜网站是聚焦热点新闻、娱乐八卦与社会动态的资讯平台，为你整理每天新鲜的吃瓜信息，快速浏览、轻松阅读。
            </p>
            <div className="mt-5 flex items-center gap-4 text-sm text-secondary-200">
              <span className="flex items-center gap-1.5">
                <i className="ri-mail-line"></i> contact@51chigua.com
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line"></i> 每日 08:00 更新
              </span>
            </div>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-bold text-background-50">资讯分类</h4>
            <ul className="flex flex-col gap-2.5 text-sm">
              {categories.map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/category/${cat.key}`}
                    className="cursor-pointer text-secondary-300 transition-colors hover:text-primary-400"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-bold text-background-50">友情链接</h4>
            <ul className="flex flex-col gap-2.5 text-sm">
              {friendLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    rel="nofollow"
                    className="cursor-pointer text-secondary-300 transition-colors hover:text-primary-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="cursor-pointer text-secondary-300 transition-colors hover:text-primary-400"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-secondary-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 51吃瓜网站 · 本站为资讯演示站点，内容均为示例，不代表真实事件。</p>
          <p>Powered by 51吃瓜编辑部</p>
        </div>
      </div>
    </footer>
  );
}